module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_03@2x-89e5a682d0574b39195c1e3d0e70b054.webp";